module.exports = __webpack_public_path__ + "img/step32_a_pull_out_fabric.111db4e7.png";